// https://www.wrike.com/open.htm?id=1068187762
// const swiperSlider = {
// 	sliderContainer: ".js-slider-container",
// 	arrowNext: ".js-slider-arrow-next",
// 	arrowPrev: ".js-slider-arrow-prev",
// 	pagination: ".js-slider-pagination"
// };

const swiperDatasets = {
	customOptions: "customOptions"
};
const swiperModifiers = {
	initialized: "initialized"
};

Shopify.theme.sections.register("slider", {
	onLoad: function () {
		this.initSlider();
	},
	initSlider() {
		this.sliderContainer = this.container.querySelector(
			swiperSlider.sliderContainer
		);

		if (!this.sliderContainer) {
			return null;
		}

		let customOptions = this.container.dataset[swiperDatasets.customOptions];
		if (customOptions) {
			customOptions = JSON.parse(customOptions);
		}

		this.options = {
			slidesPerView: "auto",
			spaceBetween: 0,
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true
            },
			navigation: {
				nextEl: swiperSlider.arrowNext,
				prevEl: swiperSlider.arrowPrev
			},
			pagination: {
				el: swiperSlider.pagination,
				type: "bullets",
				clickable: true
			},
			on: {
				afterInit: () => {
					this.sliderContainer.classList.add(swiperModifiers.initialized);
				}
			},
			...customOptions
		};

		this.slider = new Swiper(this.sliderContainer, this.options);
		this.slider.init();
	},
	onUnload: function () {
		if (!this.slider) {
			return false;
		}

		this.slider.destroy();
	}
});

Shopify.theme.sections.load("slider");